export default __webpack_public_path__ + "static/media/HumanIcon2.598be5a5.svg";